package com.sweetlime.dungeonamigo.model

import com.sweetlime.dungeonamigo.util.LongAsDoubleSerializer
import kotlinx.serialization.Serializable

@Serializable
data class SessionRoom(
    val id: String = "",
    val roomCode: String = "",
    val dmUserId: String = "",
    val dmDisplayName: String = "",
    val campaignName: String = "",
    val isActive: Boolean = true,
    @Serializable(with = LongAsDoubleSerializer::class)
    val createdAt: Long = 0,
)

@Serializable
data class SessionParticipant(
    val userId: String = "",
    val displayName: String = "",
    val characterId: String = "",
    val characterName: String = "",
    val characterClass: String = "",
    val characterLevel: Int = 1,
    val maxHp: Int = 0,
    val currentHp: Int = 0,
    val temporaryHp: Int = 0,
    val armorClass: Int = 10,
    val initiative: Int = 0,
    val initiativeRoll: Int = 0,
    val conditions: List<String> = emptyList(),
    val isConnected: Boolean = true,
    val isDm: Boolean = false,
    val avatarId: String = "",
    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitPrimaryColor: Long = 0xFFD4A843L,
    @Serializable(with = LongAsDoubleSerializer::class)
    val portraitSecondaryColor: Long = 0xFF4A90D9L,
)

@Serializable
data class RollEvent(
    val id: String = "",
    val userId: String = "",
    val displayName: String = "",
    val characterName: String = "",
    val label: String = "",
    val expression: String = "",
    val total: Int = 0,
    val isCrit: Boolean = false,
    val isCritFail: Boolean = false,
    @Serializable(with = LongAsDoubleSerializer::class)
    val timestamp: Long = 0,
)
